// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background: rgb(30, 30, 30);
    height: 5rem;
    width: 100vw;
    max-width: 75rem;
    margin: 0 auto;
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 3;
}

.logo {
    object-fit: cover;
    height: 3rem;
    width: 4rem;
}

.desktopMenuListItem {
    margin: 1rem;
    cursor: pointer;
}

.desktopMenuListItem:hover {
    color: yellow;
    padding-bottom: 0.5rem;
    border-bottom: 3px solid yellow;
}

.desktopMenuBtn {
    background: white;
    color: black;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    border-radius: 2rem;
}

.desktopMenuImg {
    object-fit: cover;
    height: 1rem;
    width: 1rem;
    margin: 1rem;
}

.active {
    color: yellow;
    padding-bottom: 0.5rem;
    border-bottom: 3px solid yellow;
}

.mobMenu {
    display: none;
    object-fit: cover;
    height: 1.8rem;
}

.navMenu {
    position: absolute;
    top: 4rem;
    right: 2rem;
    z-index: 2;
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    height:fit-content;
    min-width: 15rem;
    background: rgb(40, 40, 40);
    border-radius: 1rem;
}

.listItem {
    color: white;
    padding: 0.5rem 3rem;
    margin: 0.25rem;
    background: rgb(30, 30, 30);
}

@media screen and (max-width:720px) {
    .mobMenu {
        display: flex;
    }
    .desktopMenu {
        display: none;
    }
    .desktopMenuBtn {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/navbar.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".navbar {\n    background: rgb(30, 30, 30);\n    height: 5rem;\n    width: 100vw;\n    max-width: 75rem;\n    margin: 0 auto;\n    padding: 1rem 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: sticky;\n    top: 0;\n    z-index: 3;\n}\n\n.logo {\n    object-fit: cover;\n    height: 3rem;\n    width: 4rem;\n}\n\n.desktopMenuListItem {\n    margin: 1rem;\n    cursor: pointer;\n}\n\n.desktopMenuListItem:hover {\n    color: yellow;\n    padding-bottom: 0.5rem;\n    border-bottom: 3px solid yellow;\n}\n\n.desktopMenuBtn {\n    background: white;\n    color: black;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 1rem;\n    border-radius: 2rem;\n}\n\n.desktopMenuImg {\n    object-fit: cover;\n    height: 1rem;\n    width: 1rem;\n    margin: 1rem;\n}\n\n.active {\n    color: yellow;\n    padding-bottom: 0.5rem;\n    border-bottom: 3px solid yellow;\n}\n\n.mobMenu {\n    display: none;\n    object-fit: cover;\n    height: 1.8rem;\n}\n\n.navMenu {\n    position: absolute;\n    top: 4rem;\n    right: 2rem;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    padding: 0.5rem;\n    height:fit-content;\n    min-width: 15rem;\n    background: rgb(40, 40, 40);\n    border-radius: 1rem;\n}\n\n.listItem {\n    color: white;\n    padding: 0.5rem 3rem;\n    margin: 0.25rem;\n    background: rgb(30, 30, 30);\n}\n\n@media screen and (max-width:720px) {\n    .mobMenu {\n        display: flex;\n    }\n    .desktopMenu {\n        display: none;\n    }\n    .desktopMenuBtn {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
